module.exports = "./img/a6df207e8075da83cf2fd5354164c730.png";